import React from 'react';
import { MessageCircle, Check } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLang();
  return <section className="py-24 bg-dark-100" data-id="element-15" data-mp="c6sk7g2tg6cb">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16" data-mp="c7tzxxus1h0d">
        <div className="text-center mb-16" data-id="element-17" data-mp="85fed5zq435e">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-18" data-mp="84dymo7rishc">
            {t.finalCta.titleA} <br className="hidden md:block" data-id="element-19" data-mp="m3nh5ujfxyoh" />
            <span className="text-gold" data-id="element-20" data-mp="h5vfw9wwp07m">{t.finalCta.titleHighlight}</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-21" data-mp="h414pnbfsmgq">
            {t.finalCta.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-22" data-mp="qv577njxeeuo">
          {/* WhatsApp Card */}
          <div className="border border-[#25D366]/30 rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-23" data-mp="14uwsm9cruxip">
            {/* Background image */}
            <img src="https://cdn.magicpatterns.com/uploads/f4TXKfANotJzXqWz17dwgk/heylloyd-image-1782678048806.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-24" data-mp="zy6brjt57xw8" />
            {/* Overlays for readability */}
            <div className="absolute inset-0 bg-dark/80" data-id="element-25" data-mp="2m571qa9eflx3"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-[#25D366]/25 to-dark/90" data-id="element-26" data-mp="2r2ozd4hyueps"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#25D366]/10 rounded-full blur-3xl" data-id="element-27" data-mp="2v2r63s2k5ybx"></div>

            <div className="relative z-10" data-id="element-28" data-mp="3010zpy8mwqvf">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#25D366] text-white mb-6 shadow-[0_0_30px_rgba(37,211,102,0.4)]" data-id="element-29" data-mp="34tc35b2l2usq">
                <MessageCircle className="w-10 h-10" data-id="element-30" data-mp="39rn9hbto6n67" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-31" data-mp="3esjg3x5eonfb">
                {t.finalCta.cardTitle}
              </h3>

              <p className="text-gray-300 mb-8" data-id="element-32" data-mp="3itczcd7wle1v">{t.finalCta.cardSub}</p>

              <div className="space-y-3 text-left max-w-sm mx-auto mb-10" data-id="element-33" data-mp="1jpeita4lt0rg">
                {t.finalCta.checks.map((check, i) => <div key={i} className="flex items-center gap-3" data-id="element-34" data-mp="1en5r0h3gw4qx" data-mpi={i}>
                    <Check className="w-5 h-5 text-[#25D366] shrink-0" data-id="element-35" data-mp="1shgl7dy8gr4d" />
                    <span className="text-white font-medium" data-id="element-36" data-mp="1npez70b9jm15">{check}</span>
                  </div>)}
              </div>

              <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg" data-id="element-37" data-mp="22d9umogno4hx">
                {t.finalCta.cta}
              </a>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-dark rounded-3xl border border-white/10 p-8 md:p-10" data-id="element-38" data-mp="d06f4jhuqhkx">
            <h3 className="text-xl font-bold text-white mb-8 text-center border-b border-white/10 pb-6" data-id="element-39" data-mp="2vyaldkujxq7">
              {t.finalCta.summaryTitle}
            </h3>

            <div className="space-y-6" data-id="element-40" data-mp="6x1se5mgg3u2">
              {t.finalCta.rows.map((row, i) => <div key={i} className={`flex justify-between items-center gap-4 ${i < t.finalCta.rows.length - 1 ? 'pb-4 border-b border-white/5' : ''}`} data-id="element-41" data-mp="3pb182ub7k7ca" data-mpi={i}>
                  <span className="text-gray-400" data-id="element-42" data-mp="3kd93p0tdmsr7">{row.label}</span>
                  <span className={`font-bold text-right ${i === 0 ? 'text-gold' : 'text-white'}`} data-id="element-43" data-mp="36d82tld43lbq">
                    {row.value}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}